
export default {
    name: 'TimeLine',

    props: {
        deadline: {
            type: String,
            default: '',
        },
        stage: {
            type: Object,
            default: () => ({}),
        },
        stages: {
            type: Array,
            default: () => [],
        },
        activeIndexStage: {
            type: Number,
            default: 0,
        },
    },

    computed: {
        stageYear() {
            return this.stage?.year;
        },
    },

    methods: {
        changeActiveStage(index) {
            this.$emit('changeActiveStage', index);
        },
    },
};
